<div
[formGroup]="fG"
  class="e-input-group e-float-icon-left {{ style !== 'headless' ? 'e-float-input' : '' }} {{ fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : '' }} {{ iconClickType === 'both' ? 'hover-effect' : iconClickType === 'front' ? 'hover-effect-left' : '' }} {{ wrapperClass }}"
  [class.input-with-append]="layouttype === 'composite'"
>
  @if (iconFront) {
    @if (iconFrontTooltip) {
      <ejs-tooltip opensOn="Click" [content]="iconFrontTooltip" class="e-input-group-icon mts-icon notranslate" translate="no">
        {{ iconFront }}
      </ejs-tooltip>
    } @else {
      <span
        (click)="canClickFrontIcon() ? onIconFrontClicked() : null"
        class="e-input-group-icon mts-icon notranslate"
        [class.icon-clickable]="canClickFrontIcon()"
        [class.icon-disabled]="!canClickFrontIcon()"
        translate="no"
      >
        {{ iconFront }}
      </span>
    }
  }

  <div class="e-input-in-wrap asterisk {{ iconClickType === 'back' ? 'hover-effect-right' : '' }}">
    @if (style !== 'headless') {
      <input
        [type]="type"
        [formControlName]="fCN"
        (blur)="onBlur()"
        (keyup.enter)="onReturnKeyPress()"
        (input)="onInput($event)"
        class="e-input {{ cssClass }}"
        [attr.name]="inputName"
        [attr.autocomplete]="autocomplete"
        [attr.aria-placeholder]="placeholder ? placeholder : label"
        [attr.aria-labelledby]="label"
      />
    }

    @if (style === 'headless') {
      <input
        [type]="type"
        [formControlName]="fCN"
        (blur)="onBlur()"
        (keyup.enter)="onReturnKeyPress()"
        (input)="onInput($event)"
        class="e-input {{ cssClass }}"
        [placeholder]="placeholder"
        [attr.name]="inputName"
        [attr.autocomplete]="autocomplete"
        [attr.aria-placeholder]="placeholder ? placeholder : label"
        [attr.aria-labelledby]="label"
      />
    }

    @if (style !== 'headless') {
      <span class="e-float-line"></span>

      <label
        class="e-float-text"
        [ngClass]="{
          'e-label-top': fG.controls[fCN].value !== '' && style === 'inline',
          'e-label-bottom': fG.controls[fCN].value === '' && style === 'inline'
        }"
      >
        {{ label }}
      </label>
    }

    @if (iconBack && (type !== 'search' || (fG.controls[fCN].value ?? '').toString().length > 0)) {
      @if (iconBackTooltip) {
        <ejs-tooltip opensOn="Click" [content]="iconBackTooltip" class="e-input-group-icon mts-icon formInputTooltip" translate="no">
          {{ iconBack }}
        </ejs-tooltip>
      } @else {
        <span
          (click)="canClickBackIcon() ? onIconBackClicked() : null"
          class="e-input-group-icon mts-icon notranslate back-icon"
          [class.icon-clickable]="canClickBackIcon()"
          [class.icon-disabled]="!canClickBackIcon()"
          translate="no"
        >
          {{ iconBack }}
        </span>
      }
    }

    <div class="inputAppendContent">
      <ng-content></ng-content>
    </div>
  </div>
</div>

@if (hasErrorField) {
  <div class="error-label" role="alert">
    {{ errorText && fG.controls[fCN].invalid && fG.controls[fCN].dirty ? errorText : '' }}
  </div>
}